import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';

// import { LoginPage } from '../login/login';

/**
 * Generated class for the CommonmodalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-commonmodal',
  templateUrl: 'commonmodal.html',
})
export class CommonmodalPage {

    loginId: string;

	total: string;
	coin_unit: string;
	
	texts: any = [];
    language : string;

	constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
		public viewCtrl: ViewController
	) {
        
	}

	ionViewWillEnter() {
		//// 페이지 이름
		localStorage.setItem("pageName", "reg_modal");

        this.language = localStorage.getItem("language");
        
        // this.navBar.backButtonClick = (e:UIEvent)=>{
        //     // todo something
        //     this.navCtrl.parent.select(1);
        // }

        this._get_texts();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).commonmodal;
	}

	_close(){
        this.viewCtrl.dismiss();
    }
}


// WEBPACK FOOTER //
// ./src/pages/commonmodal/commonmodal.ts